import React, { useState, useEffect, useContext } from 'react';

import CartButton from './CartButton';
import CartDropdown from './CartDropdown';
import {getFontStylesAsync, lithuaniaMkId, polandMKId } from '../../../utils/StoreConfigManager';
import { isMobileDevice } from '../../../utils/DeviceDetector';
import { AddToCartContext } from './AddToCartContext';
import { WishlistIconClicked } from '../../../utils/Analytics';
import { AppContext } from '../../../AppContext';
import { storeTrans } from '../../../utils/StoreTranslator';

const isMobile = isMobileDevice();
const cardStyle = {
    marginBottom: 'auto'
}
const AddToCart = ({ sceneSelectorActive, cartActive, showCartActive, showSceneSelector,storeId }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [menuTitleFontStyle, setMenuTitleFontStyle] = useState();
    const [menuTextFontStyle, setMenuTextFontStyle] = useState();

    const { cartList } = useContext(AddToCartContext);
    const { currentSceneName } = useContext(AppContext);

    const storeNameMenuStyleArr = [polandMKId, lithuaniaMkId];
    useEffect(() => {
        (async () => {
            const fontStyles = await getFontStylesAsync();
            setMenuTitleFontStyle({
                fontFamily: fontStyles.popUpTitle.name,
                fontSize: fontStyles.popUpTitle.size
            });
            setMenuTextFontStyle({
                fontFamily: storeNameMenuStyleArr.includes(storeId) ? "MaryKaySansMedium" : fontStyles.popUpText.name,
                fontSize: fontStyles.popUpText.size
            })
        })()
    }, [])

    const closeCart = (e) => {
        if (e.target.tagName === 'CANVAS') {
            setShowDropdown(false);
            showCartActive(false);

            if (isMobile) {
                document.removeEventListener('touchend', closeCart);
            } else {
                document.removeEventListener('click', closeCart)
            }
        }
    }

    const handleCartButtonClick = () => {
        const showingDropdown = !showDropdown
        setShowDropdown(showingDropdown);
        if (sceneSelectorActive) {
            showSceneSelector(false);
        }
        showCartActive(!cartActive);

        if (showingDropdown) {
            WishlistIconClicked(currentSceneName)
            if (isMobile) {
                document.addEventListener('touchend', closeCart);
            } else {
                document.addEventListener('click', closeCart)
            }
        } else {
            if (isMobile) {
                document.removeEventListener('touchend', closeCart);
            } else {
                document.removeEventListener('click', closeCart)
            }
        }
    } 
     

    return (
        <div id='add-to-cart-container' className="align-right" style={cardStyle}>
            {
                cartList.length >= 0 && (
                    <CartButton
                        onClick={handleCartButtonClick}
                        text={storeTrans[storeId]['cartText']}
                        itemCount={cartList.length}
                    />
                )
            }
            <CartDropdown
                cartTitle='cartTitle'
                showDropdown={cartActive}
                menuTextFontStyle={menuTextFontStyle}
                menuTitleFontStyle={menuTitleFontStyle}
                closeMenu={handleCartButtonClick}
                removeText={storeTrans[storeId]['removeText']}
                storeId={storeId}
            />
        </div>
    )
}

export default AddToCart;
